<template>
  <modal :state="state" :index="index" @toggle-modal="reset">
    <scroll-area>

      <h3 class="modal-title">Model Properties</h3>
      <row>
        <strong>Id</strong>: {{ objectModelEntry.id }}
      </row>
      <row v-for="property in objectModelProperties" v-bind:key="property.client_id">
        <strong>{{ property.label_title }}</strong>: {{ displayProperty(property) }}
      </row>
      <div class="cta align-center">
        <button type="button" @click="reset" class="btn green">Close</button>
      </div>
    </scroll-area>

  </modal>

</template>

<script lang="ts">
import Vue from "vue";
import ObjectModel from "~/models/objectModel";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import objectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";

export default Vue.extend({
  props: {
    objectModelEntry: {
      type: Object as () => ObjectModelEntry
    },
    objectModel: {
      type: Object as () => ObjectModel
    },
    state: {
      type: Object
    }
  },
  methods: {
    reset(event) {
      this.emitHideModal(event);
    },
    displayProperty(property) {
      let rawValue = this.objectModelEntry?.displayValueFor(property.client_id)
      if (!!rawValue && property.property_type === ObjectModelPropertyRootType.PickList) {
        return property.objectModelPropertiesArray.filter(prop => rawValue.includes(prop.client_id)).map(prop => prop.label_title).join(", ")
      } else {
        return rawValue
      }
    }
  },
  computed: {
    objectModelProperties(): objectModelProperty[] {
      return this.objectModel.objectModelPropertiesArray
    }
  }
});
</script>

